import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";

import { formatNoteEditorDate } from "../utils/myTaskUtils";

export function useNoteEditorState(noteData, onNoteChange) {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef(null);
  const colorButtonRef = useRef(null);
  const methods = useForm();

  useEffect(() => {
    methods.setValue("title", noteData?.title || "");
  }, [methods, noteData?.title]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!showColorPicker) {
        return;
      }

      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target) &&
        colorButtonRef.current &&
        !colorButtonRef.current.contains(event.target)
      ) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showColorPicker]);

  const toggleColorPicker = useCallback((event) => {
    event.stopPropagation();
    setShowColorPicker((currentValue) => !currentValue);
  }, []);

  const handleColorSelect = useCallback(
    (color) => {
      onNoteChange({
        ...noteData,
        color_code: color,
      });
      setShowColorPicker(false);
    },
    [noteData, onNoteChange]
  );

  const handleContentChange = useCallback(
    (newContent) => {
      onNoteChange({
        ...noteData,
        content: newContent,
      });
    },
    [noteData, onNoteChange]
  );

  const handleTitleChange = useCallback(
    (event) => {
      methods.setValue("title", event.target.value);
      onNoteChange({
        ...noteData,
        title: event.target.value,
      });
    },
    [methods, noteData, onNoteChange]
  );

  return {
    colorButtonRef,
    colorPickerRef,
    formattedDate: useMemo(
      () => formatNoteEditorDate(noteData?.created_at),
      [noteData?.created_at]
    ),
    handleColorSelect,
    handleContentChange,
    handleTitleChange,
    methods,
    showColorPicker,
    toggleColorPicker,
  };
}
